/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, {useContext, useState} from 'react';
import { PropTypes } from "prop-types";
import {
  Container,
  Item,
  List,
  Name,
  Photo,
  Remember,
  Settings,
  SettingsItem,
  SettingsList,
  SettingsSubTitle,
  Title,
  SettingsOptions,
  Topo,
  Country,
  UserPhoto,
  IconCheckContainer,
  NameContent,
  IconNotification
} from './styles';
import Icon from "../Icon";
import { NavLink } from "react-router-dom";
import { FitinsurAPI, MessageCenter } from "utils";
import {
  GlobalAuthContext,
  GlobalLoaderContext,
  GlobalOperationContext,
} from "store/context";
import NotificationsProfile from 'components/NotificationsProfile/index';

const fitinsur = new FitinsurAPI();
const mc = new MessageCenter();
const propTypes = {
  user: PropTypes.any,
};

export default function Profile({ user, getNotificationsUnread, notifications }) {
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const [profileSceen, setProfileScreen] = useState(false);

  const changeDefaultState = (state) => {
    setProfileScreen(state);
  }

  /*
  user.remember = [
      {
          nmClient: "Jhonny Roger",
          aniversaryDate: "12/10/2001"
      },
      {
          nmClient: "Vinícius Crisol",
          aniversaryDate: "12/10/2001"
      },
      {
          nmClient: "Mailson Bonito",
          aniversaryDate: "12/10/2001"
      }
  ];
*/

  const formatDate = (date) => {
    let dt = new Date(date);
    if (!dt) {
      return "";
    }
    let dtLocale = dt
      .toLocaleDateString("en", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
      .replace(",", "")
      .split(" ");

    return `${dtLocale[0]} ${dtLocale[1]}${parseInt(dtLocale[1]) === 1 ? "st" : "th"
      } ${dtLocale[2]}`;
  };

  return (
    <Container>
    { !profileSceen &&
    <Topo>
     <UserPhoto>
        <Icon name='solid-user' />
        {/* <IconCheckContainer><Icon name='check-ok-green'/></IconCheckContainer> */}
        {notifications > 0 ?
            <IconNotification>{notifications}</IconNotification> :
            <IconCheckContainer><Icon name='check-ok-green' /></IconCheckContainer>
        }
      </UserPhoto>
      <NameContent>
        <Name>{user?.name}</Name>
        <Country>{user?.country}</Country>
      </NameContent>
    </Topo> }
    <NotificationsProfile changeDefaultState={changeDefaultState} showModal={profileSceen} getNotificationsUnread={getNotificationsUnread} />
    { !profileSceen &&
    <Settings>
      <SettingsList>
        <SettingsSubTitle>Configurações</SettingsSubTitle>
        <SettingsOptions>
        <NavLink to="/change-password"><SettingsItem><Icon name="user" />Mudar Senha</SettingsItem></NavLink>
        <NavLink to="/login"><SettingsItem><Icon name="logout" />Sair</SettingsItem></NavLink>
        </SettingsOptions>
      </SettingsList>
    </Settings> 
    }
  </Container>
  );
}
